module.exports = __webpack_public_path__ + "static/publisher-dashboard-d90b5535ce16f03d5942fea6780318a7.png";